<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex
        class="v-flex__first"
        style="margin-top: 0px !important;"
        xs12>
        <material-card
          class="v-c3-chart"
        >
         <!-- ⭐⭐⭐ 全局 Tabs（左上角控制整个页面） -->
          <v-tabs
            v-model="activeIndex"
            dense
            class="mb-0 d-inline-flex flat-tabs"
            background-color="red"
          >
            <v-tab
               v-for="(tab, index) in tabs"
               :key="index"
              :value="tab.value"
                class="custom-tab"
            >
              {{ tab.text }}
            </v-tab>
          </v-tabs>
 <!-- 标题 -->
          <material-notification
            color="brown"
            class="mb-3 h4 font-weight-bold  text-center"
          >
            正態分佈圖
            <p class="m-0">
              Factory：{{ propData.factoryName }} ｜
              PART NUMBER：{{ propData.partNumber }} ｜
              process：{{ propData.process }}｜
              station：{{ propData.station }} |
              parametername：{{ propData.parametername }} |
              periodtype：{{ propData.periodtype }} |
              時間：{{ propData.searchdate }} |
              ModelName:{{ propData.project }}
            </p>
          </material-notification>

           <div class="d-flex">

      <!-- ✅ 左侧（全部参数驱动） -->
      <div class="w-50 m-3">

        <!-- CPK + SPEC -->
        <div class="keypart-chart-info">

          <!-- CPK -->
          <div
            v-if="currentAreaData && currentAreaData.cpk !== null"
            :class="{
              'ordinary': doCpkGrade(currentAreaData.cpk),
              'bad': !doCpkGrade(currentAreaData.cpk)
            }"
          >
            <span>CPK</span>
            <p>{{ Number(currentAreaData.cpk).toFixed(2) }}</p>
            <div>
              <span>{{ currentAreaData.level }}</span>
            </div>
          </div>

          <!-- SPEC -->
          <div v-if="currentAreaData">
            <span>SPEC</span>
            <p >
               {{
    currentAreaData.specLowerValue != null
      ? currentAreaData.specLowerValue
      : '-'
  }}
  {{
    (currentAreaData.specLowerValue != null &&
    currentAreaData.specUpperValue != null)
      ? ' ~ '
      : ''
  }}
  {{
    currentAreaData.specUpperValue != null
      ? currentAreaData.specUpperValue
      : '-'
  }}
            </p>
            <div>
              <span v-if="currentAreaData.specLowerValue!=null">LOWER</span>
              <span v-if="currentAreaData.specUpperValue!=null">UPPER</span>
            </div>
          </div>

           <!-- DATA -->
          <div v-if="currentAreaData">
            <span>DATA</span>
            <p  >
               {{
    currentAreaData.min != null
      ? formatNumber(currentAreaData.min)
      : '-'
  }}
  {{
    (currentAreaData.min != null &&
    currentAreaData.max != null)
      ? ' | '
      : ''
  }}
  {{
    currentAreaData.max != null
      ? formatNumber(currentAreaData.max)
      : '-'
  }}
            </p>
            <div>
              <span v-if="currentAreaData.min!=null">Min</span>
              <span v-if="currentAreaData.max!=null">Max</span>
            </div>
          </div>

        </div>

        <!-- Sigma 表 -->
        <table
          v-if="currentAreaData"
          class="keypart-chart-table statistic-table"
        >
          <thead>
            <tr>
              <th>sigma</th>
              <th>value</th>
              <th>histogram</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                <td>Avg-6σ</td>
                <td>{{formatNumber(currentAreaData.overNegative6SigmaValue) }}</td>
                <td>{{currentAreaData.overNegative6SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg-5σ</td>
                <td>{{formatNumber(currentAreaData.overNegative5SigmaValue) }}</td>
                <td>{{currentAreaData.overNegative5SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg-4σ</td>
                <td>{{formatNumber(currentAreaData.overNegative4SigmaValue) }}</td>
                <td>{{currentAreaData.overNegative4SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg-3σ</td>
                <td>{{formatNumber(currentAreaData.overNegative3SigmaValue) }}</td>
                <td>{{currentAreaData.overNegative3SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg-2σ</td>
                <td>{{formatNumber(currentAreaData.overNegative2SigmaValue) }}</td>
                <td>{{currentAreaData.overNegative2SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg-1σ</td>
                <td>{{formatNumber(currentAreaData.overNegative1SigmaValue) }}</td>
                <td>{{currentAreaData.overNegative1SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg+1σ</td>
                <td>{{formatNumber(currentAreaData.over1SigmaValue) }}</td>
                <td>{{currentAreaData.over1SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg+2σ</td>
                <td>{{formatNumber(currentAreaData.over2SigmaValue) }}</td>
                <td>{{currentAreaData.over2SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg+3σ</td>
                <td>{{formatNumber(currentAreaData.over3SigmaValue) }}</td>
                <td>{{currentAreaData.over3SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg+4σ</td>
                <td>{{formatNumber(currentAreaData.over4SigmaValue) }}</td>
                <td>{{currentAreaData.over4SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg+5σ</td>
                <td>{{formatNumber(currentAreaData.over5SigmaValue) }}</td>
                <td>{{currentAreaData.over5SigmaQty }}</td>
              </tr>
              <tr>
                <td>Avg+6σ</td>
                <td>{{formatNumber(currentAreaData.over6SigmaValue) }}</td>
                <td>{{currentAreaData.over6SigmaQty }}</td>
              </tr>
            <!-- <tr
  v-for="(row, r) in sigmaList"
  :key="'sigma_' + r"
>
  <td>{{ row.define.name }}</td>
  <td>{{ Number(row.define.value).toFixed(4) }}</td>
  <td>{{ row.amount }}</td>
</tr> -->
          </tbody>
        </table>

      </div>

      <!-- ✅ 右侧（完全保留你的结构，仅微调容器） -->
      <div class="w-50 m-3">

        <div
          class="chart-btn c3-chart c3-click"
          style="margin-top: 0rem!important;"
        >

          <!-- 图表 -->
           <!-- 有 Sigma 数据显示图表 -->
    <vue-c3
      v-if="hasSigmaData"
      :handler="handler_bar"
    />

    <!-- 全部为 0 显示提示 -->
    <div
      v-else
      class="text-center"
      style="padding: 100px 0;"
    >
      無 Sigma 資料
    </div>

        </div>

      </div>

    </div>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueC3 from 'vue-c3'
import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'ShowLcdCalibrationDeltaEDistributionBarChart',
  components: {
    VueC3
  },
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      propData: {},
      // lcdFilterUpdateTime: '',
      calibrationMode: 'NoGM',
      calibrationModeMenu: [],
      activeIndex: 0,
      datatype: 4,
      hasSigmaData: true,
      Min: {
        value: 0
      },
      Max: {
        value: 0
      },
      Avg: {
        value: 0
      },
      RangeMin: 0,
      RangeMax: 9999,
      RangeMinLimit: 0.3,
      RangeMaxLimit: 5.7,
      xRange: 0.3,
      LessRangeCount: {
        value: 0
      },
      OverRangeCount: {
        value: 0
      },
      // RangeCount: 1,
      responseAreaData: [],
      barXaxisItem: ['value'],
      barXaxisItemName: ['Delta E Distribution'],
      barXaxisName: [],
      barXaxisValue: [],
      handler_bar: new Vue(),
      // ✅ 左侧核心数据（假数据）
      responseStandardData: {
        cpk: 1.33,

        lowerSpecValue: 10,
        upperSpecValue: 20,

        // 平均值 & 标准差（你后面算正态分布可能会用）
        average: 15,
        standardDeviation: 2,

        // 分布数据（Sigma）
        distributionCoverageList: [
          {
            define: { type: 'Sigma', name: 'Avg-6L', value: 1 },
            amount: 0
          },
          {
            define: { type: 'Sigma', name: 'Avg-5L', value: 1 },
            amount: 0
          },
          {
            define: { type: 'Sigma', name: 'Avg-4L', value: 1 },
            amount: 0
          },
          {
            define: { type: 'Sigma', name: 'Avg-3L', value: 1 },
            amount: 0
          },
          {
            define: { type: 'Sigma', name: 'Avg-2L', value: 1 },
            amount: 0
          },
          {
            define: { type: 'Sigma', name: 'Avg-1L', value: 9 },
            amount: 10
          },
          {
            define: { type: 'Sigma', name: 'Avg+1L', value: 7 },
            amount: 2
          },
          {
            define: { type: 'Sigma', name: 'Avg+2L', value: 11 },
            amount: 8
          },
          {
            define: { type: 'Sigma', name: 'Avg+3L', value: 13 },
            amount: 15
          },
          {
            define: { type: 'Sigma', name: 'Avg+4L', value: 1 },
            amount: 0
          },
          {
            define: { type: 'Sigma', name: 'Avg+5L', value: 1 },
            amount: 0
          },
          {
            define: { type: 'Sigma', name: 'Avg+6L', value: 1 },
            amount: 0
          }
        ]
      },

      xRangeOptions: [
        { text: 0.1, value: 0.1 },
        { text: 0.3, value: 0.3 },
        { text: 0.5, value: 0.5 },
        { text: 1.0, value: 1.0 }
      ],
      CpkGradeList: []

    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    options_line () {
      const labels = [
        'Avg-6σ',
        'Avg-5σ',
        'Avg-4σ',
        'Avg-3σ',
        'Avg-2σ',
        'Avg-1σ',
        'Avg+1σ',
        'Avg+2σ',
        'Avg+3σ',
        'Avg+4σ',
        'Avg+5σ',
        'Avg+6σ'
      ]

      const qtyList = [
        this.currentAreaData.overNegative6SigmaQty,
        this.currentAreaData.overNegative5SigmaQty,
        this.currentAreaData.overNegative4SigmaQty,
        this.currentAreaData.overNegative3SigmaQty,
        this.currentAreaData.overNegative2SigmaQty,
        this.currentAreaData.overNegative1SigmaQty,
        this.currentAreaData.over1SigmaQty,
        this.currentAreaData.over2SigmaQty,
        this.currentAreaData.over3SigmaQty,
        this.currentAreaData.over4SigmaQty,
        this.currentAreaData.over5SigmaQty,
        this.currentAreaData.over6SigmaQty
      ]

      // 👇 Value
      const valueList = [
        this.currentAreaData.overNegative6SigmaValue,
        this.currentAreaData.overNegative5SigmaValue,
        this.currentAreaData.overNegative4SigmaValue,
        this.currentAreaData.overNegative3SigmaValue,
        this.currentAreaData.overNegative2SigmaValue,
        this.currentAreaData.overNegative1SigmaValue,
        this.currentAreaData.over1SigmaValue,
        this.currentAreaData.over2SigmaValue,
        this.currentAreaData.over3SigmaValue,
        this.currentAreaData.over4SigmaValue,
        this.currentAreaData.over5SigmaValue,
        this.currentAreaData.over6SigmaValue
      ]
      // 👇 如果對應的 y 值是 0，x 軸文字顯示空字串
      const rawData = labels.map((label, index) => ({
        label,
        qty: qtyList[index],
        value: valueList[index]
      }))

      // 👇 value=0 的整筆移除
      const filteredData = rawData.filter(x => x.value !== 0)

      const xData = filteredData.map(x => x.label)
      const qtyData = filteredData.map(x => x.qty)
      const maxTick = Math.max(2, Math.max(...qtyData) + 1)
      console.info(maxTick)
      return {
        data: {
          x: 'x',
          columns: [
            [
              'x',
              ...xData
            ],

            // 柱狀圖（Qty）
            [
              '統計次數',
              ...qtyData
            ],

            // 折線圖（Value）
            [
              '正態分佈',
              ...qtyData
            ]
          ],

          type: 'bar',

          types: {
            正態分佈: 'spline'
          }
        },

        axis: {
          x: {
            type: 'category',
            tick: {
              rotate: -45,
              multiline: false
            }
          },

          // 左軸
          y: {
            min: 0,
            max: maxTick,
            padding: {
              bottom: 0,
              top: 0
            },
            label: {
              text: '統計次數',
              position: 'outer-middle'
            }
          }
        },

        // 👇 中間 Avg 紅色虛線
        // grid: {
        //   x: {
        //     lines: [
        //       {
        //         value: 6, // Avg 的 index
        //         text: 'AVG',
        //         class: 'avg-line'
        //       }
        //     ]
        //   }
        // },

        tooltip: {
          contents: (d) => {
            const current = filteredData[d[0].index]

            // 只抓柱狀圖
            const amount = d.find(i => i.id === '統計次數')

            return `
      <table class="c3-tooltip">
        <tbody>
          <tr>
            <th colspan="2">${current.label}</th>
          </tr>
          <tr>
            <td>統計次數</td>
            <td>${amount ? amount.value : '-'}</td>
          </tr>
        </tbody>
      </table>
    `
          }
        },

        legend: {
          show: false
        },

        size: {
          width: ((window.innerWidth - this.shrink) * 0.5) - 64,
          height: 500
        },

        padding: {
          top: 20,
          right: 50,
          bottom: 0,
          left: 50
        },

        spline: {
          interpolation: {
            type: 'monotone'
          }
        }
      }
    },
    sigmaList () {
      if (!this.responseStandardData || !this.responseStandardData.distributionCoverageList) {
        return []
      }

      return this.responseStandardData.distributionCoverageList.filter(row => {
        return row.define && row.define.type === 'Sigma'
      })
    },
    tabs () {
      return (this.responseAreaData || []).map((item, index) => ({
        index,
        value: index,
        text: this.getTabName(item.statisticTestItemType)
      }))
    },

    currentAreaData () {
      return this.responseAreaData[this.activeIndex] || {}
    }
  },
  watch: {
    xRange (val) {
      this.doSummary()
    },
    calibrationMode () {
      this.doSubmit()
    },
    responseAreaData: {
      immediate: true,
      handler (val) {
        if (val && val.length > 0) {
          const index = val.findIndex(
            item => String(item.statisticTestItemType) === String(this.datatype)
          )
          const nextIndex = index !== -1 ? index : 0
          // activeIndex 未變時 watch 不會觸發，需手動檢查 Sigma
          if (this.activeIndex === nextIndex) {
            this.$nextTick(() => {
              this.checkSigmaData()
            })
          } else {
            this.activeIndex = nextIndex
          }
        }
      }
    },
    activeIndex () {
      this.checkSigmaData()
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/ctq/CTQAnalyzer/ShowCTQNormaldistributionplot')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          const cache = sessionStorage.getItem('cacheFilterInfo')
          console.info(cache)
          if (cache) {
            // ✅ 優先用 sessionStorage 中的副本
            this.propData = JSON.parse(cache)
          } else {
            // ✅ 第一次從 localStorage 拿到後，存入 sessionStorage
            const raw = localStorage.getItem('ctqFilterInfo')
            if (raw) {
              this.propData = JSON.parse(raw)
              sessionStorage.setItem('cacheFilterInfo', raw)
            }
          }
          this.datatype = this.$route.query.statisticTestItemType
          // this.lcdFilterUpdateTime = localStorage.getItem('lcdFilterUpdateTime')
          this.loadingView = true
          this.doSubmit()
          this.loadingView = false
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    doSummary (type) {
      if (type === 'init') {
        this.handler_bar.$emit('init', this.options_line)
      } else {
        this.handler_bar.$emit('dispatch', chart => {
          const options = {
            columns: [this.barXaxisName].concat(this.barXaxisValue)
          }
          chart.load(options)
        })
      }
    },
    checkSigmaData () {
      if (!this.responseAreaData || this.responseAreaData.length === 0) {
        return
      }
      const sigmaValues = [
        this.currentAreaData.overNegative6SigmaValue,
        this.currentAreaData.overNegative5SigmaValue,
        this.currentAreaData.overNegative4SigmaValue,
        this.currentAreaData.overNegative3SigmaValue,
        this.currentAreaData.overNegative2SigmaValue,
        this.currentAreaData.overNegative1SigmaValue,
        this.currentAreaData.over1SigmaValue,
        this.currentAreaData.over2SigmaValue,
        this.currentAreaData.over3SigmaValue,
        this.currentAreaData.over4SigmaValue,
        this.currentAreaData.over5SigmaValue,
        this.currentAreaData.over6SigmaValue
      ].map(v => Number(v || 0))
      this.hasSigmaData = new Set(sigmaValues).size > 1
      if (!this.hasSigmaData) {
        this.snackbar = true
        this.snackbarColor = 'orange'
        this.snackbarMsg = '無 Sigma 資料'
      } else {
        this.$nextTick(() => {
          this.doSummary('init')
        })
      }
    },
    doSubmit () {
      if (this.propData.responseData != null && this.propData.responseData.length > 0) {
        this.responseAreaData = this.propData.responseData
      } else {
        const body = {
          vendorCode: this.propData.vendorCode,
          partNumber: this.propData.partNumber,
          processCode: this.propData.processCode,
          stationCode: this.propData.stationCode,
          testItemCode: this.propData.testItemCode,
          statisticTimeType: this.propData.statisticTimeType,
          statisticTimeValue: this.propData.statisticTimeValue,
          year: this.propData.year
        }
        this.$http.post(`/api/ctq/test/statistic/getStatisticData`, body).then(res => res.data)
          .then(res => {
            if (res.status === 'success') {
              this.responseAreaData = res.data
            }
          })
      }
    },
    doCpkGrade (cpk) {
      return Number(cpk) >= 1.33
    },
    doCpkGradeName (cpk) {
      let result = false
      this.CpkGradeList.forEach(e => {
        if ((e.upperSpecLimit ? e.upperSpecLimit : 999999999999999) > cpk && cpk >= (e.lowerSpecLimit ? e.lowerSpecLimit : -999999999999999)) {
          result = e.evaluation
        }
      })
      return result
    },
    getTabName (type) {
      const map = {
        4: '實測',
        5: '實測最小',
        6: '實測最大'
      }
      return map[type] || '未知'
    },
    formatNumber (value) {
      return value != null
        ? Number(value).toFixed(2)
        : '-'
    },
    buildChartData () {
      const mapAmount = {}
      const mapValue = {}

      const list = this.responseStandardData.distributionCoverageList || []

      list.forEach(item => {
        if (!item.define || item.define.type !== 'Sigma') return

        const name = item.define.name
        const amount = Number(item.amount) || 0
        const value = Number(item.define.value) || 0

        // 👉 累加 amount
        if (!mapAmount[name]) {
          mapAmount[name] = 0
        }
        mapAmount[name] += amount

        // 👉 value 只取一个（第一次出现）
        if (mapValue[name] === undefined) {
          mapValue[name] = value
        }
      })

      // 👉 转换成数组
      const x = ['x']
      const yAmount = ['統計次數']
      const yValue = ['value線']

      Object.keys(mapAmount).forEach(name => {
        x.push(name)
        yAmount.push(mapAmount[name])
        yValue.push(mapValue[name])
      })

      return { x, yAmount, yValue }
    }
  }
}
</script>
<style>
/* .c3-axis-x .tick tspan:hover {
  cursor: pointer;
} */
.v-tabs {
  width: auto !important;
}

.v-tabs .v-tab {
  background: transparent !important;
  color: #333;
  border-radius: 6px;
  transition: 0.2s;
}

.v-tabs .v-tab--active {
  background: #8d6e63 !important;
  color: #fff !important;
}

.v-tabs .v-tab:hover {
  background: rgba(141, 110, 99, 0.15);
}
</style>
